import { combineReducers } from 'redux';

import {
  LIBRARY_MODIFIER_SET_OUTLETS,
  LIBRARY_MODIFIER_HIDE_DELETE_MODIFIER_MODAL,
  LIBRARY_MODIFIER_SHOW_DELETE_MODIFIER_MODAL,
  LIBRARY_MODIFIER_SHOW_APPLY_SET_ITEM_MODAL,
  LIBRARY_MODIFIER_HIDE_APPLY_SET_ITEM_MODAL,
  LIBRARY_MODIFIER_SET_MODIFIER_DETAIL,
  LIBRARY_MODIFIER_SET_MODIFIERS,
  LIBRARY_MODIFIER_SET_TOTAL_PAGE,
  LIBRARY_MODIFIER_SET_DELETED_MODIFIER,
  LIBRARY_MODIFIER_SET_CURRENT_PAGE,
  LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_ITEMS,
  LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_CURRENT_PAGE,
  LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_TOTAL_PAGE,
  LIBRARY_MODIFIER_SHOW_MODIFIER_OPTIONS_MODAL,
  LIBRARY_MODIFIER_HIDE_MODIFIER_OPTIONS_MODAL,
  LIBRARY_MODIFIER_SET_PREVIOUS_MODIFIER_FORM,
  LIBRARY_MODIFIER_OPEN_RIGHT_COLUMN,
  LIBRARY_MODIFIER_CLOSE_RIGHT_COLUMN,
  LIBRARY_MODIFIER_IS_SUBMITTING_FORM,
  LIBRARY_MODIFIER_SET_ALL_ITEM_CONFIRMATION_MODAL_OPEN,
  LIBRARY_MODIFIER_SET_ALL_ITEM_CONFIRMATION_MODAL_CLOSE,
  LIBRARY_MODIFIER_SET_INGREDIENTS_LIST,
  LIBRARY_MODIFIER_SET_SUBSCRIPTION,
  LIBRARY_MODIFIER_SHOW_UNABLE_TO_SAVE_ALL_OUTLET_MODAL,
  LIBRARY_MODIFIER_HIDE_UNABLE_TO_SAVE_ALL_OUTLET_MODAL,
} from '../../actions/library/modifier/constants';
import createReducer from '../../utils/createReducer';

const applySetItems = createReducer(
  {
    items: [],
    currentPage: 0,
    totalPage: 0,
  },
  {
    [LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_ITEMS]: (draft, { payload }) => {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      draft.items = payload.items;
    },

    [LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_CURRENT_PAGE]: (
      draft,
      { payload }
    ) => {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      draft.currentPage = payload.currentPage;
    },

    [LIBRARY_MODIFIER_APPLY_SET_ITEM_SET_TOTAL_PAGE]: (draft, { payload }) => {
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      draft.totalPage = payload.totalPage;
    },
  }
);

const currentPage = createReducer(null, {
  [LIBRARY_MODIFIER_SET_CURRENT_PAGE]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.currentPage,
});

const deletedModifier = createReducer(null, {
  [LIBRARY_MODIFIER_SET_DELETED_MODIFIER]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.deletedModifier,
});

const isSubmittingForm = createReducer(false, {
  [LIBRARY_MODIFIER_IS_SUBMITTING_FORM]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.isSubmittingForm,
});

const modifierDetail = createReducer(null, {
  [LIBRARY_MODIFIER_SET_MODIFIER_DETAIL]: (draft, { payload }) =>
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    payload.modifier,
});

const modifiers = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [LIBRARY_MODIFIER_SET_MODIFIERS]: (draft, { payload }) => payload.modifiers,
});

const openRightColumn = createReducer(false, {
  [LIBRARY_MODIFIER_OPEN_RIGHT_COLUMN]: () => true,
  [LIBRARY_MODIFIER_CLOSE_RIGHT_COLUMN]: () => false,
});

const outlets = createReducer([], {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [LIBRARY_MODIFIER_SET_OUTLETS]: (draft, { payload }) => payload.outlets,
});

const previousModifierForm = createReducer(
  {
    name: null,
    options: [],
  },
  {
    [LIBRARY_MODIFIER_SET_PREVIOUS_MODIFIER_FORM]: (draft, { payload }) => ({
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      ...payload.previousModifierForm,
    }),
  }
);

const showApplySetItemModal = createReducer(false, {
  [LIBRARY_MODIFIER_SHOW_APPLY_SET_ITEM_MODAL]: () => true,
  [LIBRARY_MODIFIER_HIDE_APPLY_SET_ITEM_MODAL]: () => false,
});

const showDeleteModifierModal = createReducer(false, {
  [LIBRARY_MODIFIER_SHOW_DELETE_MODIFIER_MODAL]: () => true,
  [LIBRARY_MODIFIER_HIDE_DELETE_MODIFIER_MODAL]: () => false,
});

const showModifierOptionsModal = createReducer(false, {
  [LIBRARY_MODIFIER_SHOW_MODIFIER_OPTIONS_MODAL]: () => true,
  [LIBRARY_MODIFIER_HIDE_MODIFIER_OPTIONS_MODAL]: () => false,
});

const totalPage = createReducer(null, {
  // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
  [LIBRARY_MODIFIER_SET_TOTAL_PAGE]: (draft, { payload }) => payload.totalPage,
});

const showSetAllItemConfirmationModal = createReducer(false, {
  [LIBRARY_MODIFIER_SET_ALL_ITEM_CONFIRMATION_MODAL_OPEN]: () => true,
  [LIBRARY_MODIFIER_SET_ALL_ITEM_CONFIRMATION_MODAL_CLOSE]: () => false,
});

const ingredientsList = createReducer(
  {
    results: [],
    total_pages: 0,
    total_counts: 0,
    currentPage: 1,
    isLoading: true,
    isEmpty: false,
  },
  {
    [LIBRARY_MODIFIER_SET_INGREDIENTS_LIST]: (draft, { payload }) =>
      // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
      payload.data,
  }
);

const ingredientSubscription = createReducer(
  {},
  {
    [LIBRARY_MODIFIER_SET_SUBSCRIPTION]: (draft, { payload }) => payload,
  }
);

const showUnableToSaveAllOutletModal = createReducer(false, {
  [LIBRARY_MODIFIER_SHOW_UNABLE_TO_SAVE_ALL_OUTLET_MODAL]: () => true,
  [LIBRARY_MODIFIER_HIDE_UNABLE_TO_SAVE_ALL_OUTLET_MODAL]: () => false,
});

export default combineReducers({
  applySetItems,
  currentPage,
  deletedModifier,
  isSubmittingForm,
  modifierDetail,
  modifiers,
  openRightColumn,
  outlets,
  previousModifierForm,
  showApplySetItemModal,
  showDeleteModifierModal,
  showModifierOptionsModal,
  showUnableToSaveAllOutletModal,
  totalPage,
  showSetAllItemConfirmationModal,
  ingredientsList,
  ingredientSubscription,
});
